<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)">
    <!-- ***************************** HEADER ********************************* -->
    <subpage-header label="Update Parcel(s)" @back_Clicked="close" />

    <!-- ***************************** BODY ********************************* -->
    <div class="spl-edit-template">
      <div class="padding-wrapper">
        <div class="row">
          <div class="col12">
            <!-- ***********************  GENERAL INFO   ***********************************

                    -->
            <div class="spl-h3 spl-h3--first">
              General Info
            </div>
            <!-- <div class="row">
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Is_Forward"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Is_Forward')">
                  Update Direction
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Is_Forward"
                  :options="[{ value: null, label: 'Do not update' }, {label: 'Forward', value: true}, {label: 'Return', value: false}]"
                  :hide-selected="true"
                  :searchable="false"
                  @updateDropdownValue="direction_set" />
              </div>
            </div>
            <br> -->
            <div class="row">
              <div class="col6">
                <!-- *********************** Customer  *********************************** -->
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Customer"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Customer')">
                  Update Customer
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Customer_ID"
                  :options="customerOptionsWithModification"
                  :hide-selected="false"
                  :searchable="true"
                  :invalid="$v.update_parcel_list_model.Customer_ID && $v.update_parcel_list_model.Customer_ID.$invalid"
                  @updateDropdownValue="customer_set"
                  @close="callTouch($v.update_parcel_list_model.Customer_ID)" />
                <span v-if="$v.update_parcel_list_model.Customer_ID && $v.update_parcel_list_model.Customer_ID.$invalid" class="error">Please select a Customer</span>
              </div>
              <div class="col6">
                <!-- *********************** Country  *********************************** -->
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Country"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Country')">
                  Update Country
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Country_ID"
                  :options="countryOptionsWithModification"
                  :hide-selected="false"
                  :searchable="true"
                  :invalid="$v.update_parcel_list_model.Country_ID && $v.update_parcel_list_model.Country_ID.$invalid"
                  @updateDropdownValue="country_set"
                  @close="callTouch($v.update_parcel_list_model.Country_ID)" />
                <span v-if="$v.update_parcel_list_model.Country_ID && $v.update_parcel_list_model.Country_ID.$invalid" class="error">Please select a Country</span>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col6">
                <!-- *********************** Service Level  *********************************** -->
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Service_Level"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Service_Level')">
                  Update Service Level
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Service_Level_ID"
                  :options="serviceLevelOptionsWithModification"
                  :hide-selected="false"
                  :searchable="true"
                  :invalid="$v.update_parcel_list_model.Service_Level_ID && $v.update_parcel_list_model.Service_Level_ID.$invalid"
                  @updateDropdownValue="service_level_set"
                  @close="callTouch($v.update_parcel_list_model.Service_Level_ID)" />
                <span v-if="$v.update_parcel_list_model.Service_Level_ID && $v.update_parcel_list_model.Service_Level_ID.$invalid" class="error">Please select a Service Level</span>
              </div>
              <div class="col6">
                <!-- *********************** Booked Pickup date  *********************************** -->
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Booked_Pickup_Date"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Booked_Pickup_Date')">
                  Update Booked Pickup Date
                </form-checkbox>
                <form-datepicker
                  v-model="update_parcel_list_model.Booked_Pickup_Date"
                  :required="false"
                  :invalid="$v.update_parcel_list_model.Booked_Pickup_Date && $v.update_parcel_list_model.Booked_Pickup_Date.$invalid"
                  @input="booked_Pickup_Date_Changed" />
                <span v-if="$v.update_parcel_list_model.Booked_Pickup_Date && $v.update_parcel_list_model.Booked_Pickup_Date.$invalid" class="error">Please select a valid Pickup Date</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col12">
            <!-- *********************** ADDRESS IFNO   ***********************************

                    -->
            <div class="spl-h3">
              Address Info
            </div>
            <div v-if="(update_parcel_list_model.Customer_ID <= 0)" class="row">
              <div class="col12">
                <div class="spl-text__formatted">
                  All parcels needs to have the same customer in order to update the address.
                </div>
              </div>
            </div>
            <div v-if="(update_parcel_list_model.Customer_ID > 0)" class="row">
              <!-- *********************** Pickup Address  *********************************** -->
              <div class="col10">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Pickup_Address"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Pickup_Address')">
                  Update Pickup Address
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Pickup_Address_ID"
                  :options="found_pickup_addresses"
                  :internal-search="false"
                  :required="true"
                  :invalid="$v.update_parcel_list_model.Pickup_Address_ID && $v.update_parcel_list_model.Pickup_Address_ID.$invalid"
                  placeholder="Search for Addresses..."
                  icon="search"
                  no-options="Type at least 3 characters to start search"
                  @search-change="getAddresses($event, 'pickup')"
                  @updateDropdownValue="update_Pickup_Address"
                  @close="callTouch($v.update_parcel_list_model.Pickup_Address_ID)" />
                <span v-if="$v.update_parcel_list_model.Pickup_Address_ID && $v.update_parcel_list_model.Pickup_Address_ID.$invalid" class="error">Please select a a Pickup Address</span>

                <div class="spl-text__formatted">
                  {{ pickup_address_formatted }} <br><br>
                </div>
              </div>
              <div class="col1">
                <form-label v-if="!is_mobile" />
                <form-button :wide="is_mobile" @onClick="show_Edit_Pickup_Address">
                  Edit
                </form-button>
                <edit-create-address-modal
                  :address-model="edit_pickup_address_object"
                  :customer-key="update_parcel_list_model.Customer_ID"
                  :is-visible="show_create_pickup_address"
                  @close="close_Address"
                  @address_Created="pickup_Address_Created" />
              </div>
              <div class="col1">
                <form-label v-if="!is_mobile" />
                <form-button :wide="is_mobile" @onClick="show_Create_Pickup_Address">
                  New
                </form-button>
              </div>
            </div>
            <div v-if="(update_parcel_list_model.Customer_ID > 0)" class="row">
              <!-- *********************** Delivery Address  *********************************** -->
              <div class="col10">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Delivery_Address"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Delivery_Address')">
                  Update Delivery Address
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Delivery_Address_ID"
                  :options="found_delivery_addresses"
                  :internal-search="false"
                  :required="true"
                  :invalid="$v.update_parcel_list_model.Delivery_Address_ID && $v.update_parcel_list_model.Delivery_Address_ID.$invalid"
                  placeholder="Search for Addresses..."
                  icon="search"
                  no-options="Type at least 3 characters to start search"
                  @search-change="getAddresses($event, 'delivery')"
                  @updateDropdownValue="update_Delivery_Address"
                  @close="callTouch($v.update_parcel_list_model.Delivery_Address_ID)" />
                <span v-if="$v.update_parcel_list_model.Delivery_Address_ID && $v.update_parcel_list_model.Delivery_Address_ID.$invalid" class="error">Please select a a Delivery Address</span>

                <!-- *********************** Show Delivery Address  *********************************** -->
                <div class="spl-text__formatted spl-row-space">
                  {{ delivery_address_formatted }}
                </div>
              </div>
              <div class="col1">
                <form-label v-if="!is_mobile" />
                <form-button :wide="is_mobile" @onClick="show_Edit_Delivery_Address">
                  Edit
                </form-button>
                <edit-create-address-modal
                  :address-model="edit_delivery_address_object"
                  :customer-key="update_parcel_list_model.Customer_ID"
                  :country-key="update_parcel_list_model.Country_ID"
                  :is-visible="show_create_delivery_address"
                  @close="close_Address"
                  @address_Created="delivery_Address_Created" />
              </div>
              <div class="col1">
                <form-label v-if="!is_mobile" />
                <form-button :wide="is_mobile" @onClick="show_Create_Delivery_Address">
                  New
                </form-button>
              </div>
            </div>
            <div class="row">
              <div class="col12">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Contact"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Contact')">
                  Update Contact
                </form-checkbox>
                <contact-component
                  :parcel-data="update_parcel_list_model"
                  :is-selecting="true"
                  :invalid="$v.update_parcel_list_model.Contact_ID && $v.update_parcel_list_model.Contact_ID.$invalid"
                  form-style="parcelUpdate"
                  @contactSelected="update_Contact" />
                <span v-if=" $v.update_parcel_list_model.Contact_ID && $v.update_parcel_list_model.Contact_ID.$invalid" class="error">Please select a Contact</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col12">
            <!-- Service Info -->
            <div class="spl-h3">
              Service Info
            </div>
            <div class="row">
              <!-- *************************** Security ***************************-->
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Dangerous_Goods"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Dangerous_Goods')">
                  Update Dangerous Good
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Dangerous_Goods"
                  :hide-selected="false"
                  :searchable="true"
                  :options="[{ label: 'Do not update', value: null},{ label: 'Yes', value: true},{ label: 'No', value: false} ]"
                  :invalid="$v.update_parcel_list_model.Dangerous_Goods && $v.update_parcel_list_model.Dangerous_Goods.$invalid"
                  @updateDropdownValue="dangerous_goods_set"
                  @close="callTouch($v.update_parcel_list_model.Dangerous_Goods)" />
                <span v-if="$v.update_parcel_list_model.Dangerous_Goods && $v.update_parcel_list_model.Dangerous_Goods.$invalid" class="error">Please select an option</span>

                <br>
              </div>
            </div>
            <div class="row">
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_XRayed"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_XRayed')">
                  Update X-Rayed
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.XRayed"
                  :hide-selected="false"
                  :searchable="true"
                  :options="[{ label: 'Do not update', value: null},{ label: 'Yes', value: true},{ label: 'No', value: false} ]"
                  :invalid="$v.update_parcel_list_model.XRayed && $v.update_parcel_list_model.XRayed.$invalid"
                  @updateDropdownValue="xrayed_set"
                  @close="callTouch($v.update_parcel_list_model.XRayed)" />
                <span v-if="$v.update_parcel_list_model.XRayed && $v.update_parcel_list_model.XRayed.$invalid" class="error">Please select an option</span>
                <br>
              </div>
            </div>
            <div class="row">
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_LMU"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_LMU')">
                  Update Last Mile Upgrade
                </form-checkbox>
                <form-filtered-select
                  :selected-key="update_parcel_list_model.Last_Mile_Upgrade"
                  :hide-selected="false"
                  :searchable="true"
                  :options="[{ label: 'Do not update', value: null},{ label: 'Yes', value: true},{ label: 'No', value: false} ]"
                  :invalid="$v.update_parcel_list_model.Last_Mile_Upgrade && $v.update_parcel_list_model.Last_Mile_Upgrade.$invalid"
                  @updateDropdownValue="lmu_set"
                  @close="callTouch($v.update_parcel_list_model.Last_Mile_Upgrade)" />
                <span v-if="$v.update_parcel_list_model.Last_Mile_Upgrade && $v.update_parcel_list_model.Last_Mile_Upgrade.$invalid" class="error">Please select an option</span>
                <br>
              </div>
            </div>
            <div class="row">
              <div class="col8">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Open_Deadline"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Open_Deadline')">
                  Update Open Deadline
                </form-checkbox>
                <form-datepicker
                  v-model="update_parcel_list_model.Open_Deadline"
                  :invalid="$v.update_parcel_list_model.Open_Deadline && $v.update_parcel_list_model.Open_Deadline.$invalid"
                  type="datetime"
                  min="2009-01-01"
                  class="spl-row-space"
                  @input="open_Deadline_Changed" />
                <span
                  v-if="$v.update_parcel_list_model.Open_Deadline && $v.update_parcel_list_model.Open_Deadline.$invalid"
                  class="error"
                  style="margin-top: -30px;">Please select a valid open deadline</span>
                <br>
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Close_Deadline"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Close_Deadline')">
                  Update Close Deadline
                </form-checkbox>
                <form-datepicker
                  v-model="update_parcel_list_model.Close_Deadline"
                  :invalid="$v.update_parcel_list_model.Close_Deadline && $v.update_parcel_list_model.Close_Deadline.$invalid"
                  type="datetime"
                  min="2009-01-01"
                  class="spl-row-space"
                  @input="close_Deadline_Changed" />
                <span
                  v-if="$v.update_parcel_list_model.Close_Deadline && $v.update_parcel_list_model.Close_Deadline.$invalid"
                  class="error"
                  style="margin-top: -30px;">Please select a valid close deadline</span>
                <br><br>
              </div>
            </div>

            <!-- ***********************  WEIGHTS AND DIMENSIONS   *********************************** -->
            <div class="spl-h3">
              Weight &amp; Dimensions
            </div>
            <!-- *********************** Dimensions  *********************************** -->
            <div class="row">
              <div class="col12">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Dimensions"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Dimensions')">
                  Update Dimensions
                </form-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col4">
                <form-input
                  v-model="update_parcel_list_model.Length"
                  :invalid="$v.update_parcel_list_model.Length && $v.update_parcel_list_model.Length.$invalid"
                  placeholder="Length (cm)"
                  type="float"
                  @input="dimensions_Changed" />
                <span
                  v-if="$v.update_parcel_list_model.Length && !$v.update_parcel_list_model.Length.integer"
                  class="error"
                  style="margin-top: -10px; margin-bottom: 10px">Length has to be a number</span>
              </div>
              <div class="col4">
                <form-input
                  v-model="update_parcel_list_model.Width"
                  :invalid="$v.update_parcel_list_model.Width && $v.update_parcel_list_model.Width.$invalid"
                  placeholder="Width (cm)"
                  type="float"
                  @input="dimensions_Changed" />
                <span
                  v-if="$v.update_parcel_list_model.Width && !$v.update_parcel_list_model.Width.integer"
                  class="error"
                  style="margin-top: -10px; margin-bottom: 10px">Width has to be a number</span>
              </div>
              <div class="col4">
                <form-input
                  v-model="update_parcel_list_model.Height"
                  :invalid="$v.update_parcel_list_model.Height && $v.update_parcel_list_model.Height.$invalid"
                  placeholder="Height (cm)"
                  type="float"
                  @input="dimensions_Changed" />
                <span
                  v-if="$v.update_parcel_list_model.Height && !$v.update_parcel_list_model.Height.integer"
                  class="error"
                  style="margin-top: -10px; margin-bottom: 10px">Height has to be a number</span>
              </div>
            </div>
            <div class="row">
              <!-- *********************** Volume  *********************************** -->
              <!-- Only Required if no dimensions given-->
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Volume"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Volume')">
                  Update Volume
                </form-checkbox>
                <form-input
                  v-model="update_parcel_list_model.Volume"
                  :invalid="$v.update_parcel_list_model.Volume && $v.update_parcel_list_model.Volume.$invalid"
                  placeholder="Volume (m3)"
                  type="float"
                  @input="volume_Changed" />
                <span v-if="$v.update_parcel_list_model.Volume && !$v.update_parcel_list_model.Volume.decimal" class="error">Volume has to be a number</span>
              </div>

              <!-- *********************** Weight  *********************************** -->
              <div class="col6">
                <form-checkbox
                  :checked="update_parcel_list_model.Update_Weight"
                  class="spl-edit-template__select-field"
                  tabindex="-1"
                  @checkboxChanged="update_checkbox_set($event, 'Update_Weight')">
                  Update Weight
                </form-checkbox>
                <form-input
                  v-model="update_parcel_list_model.Weight"
                  :invalid="$v.update_parcel_list_model.Weight && $v.update_parcel_list_model.Weight.$invalid"
                  placeholder="Weight (kg)"
                  type="float"
                  @input="weight_Changed" />
                <span v-if="$v.update_parcel_list_model.Weight && !$v.update_parcel_list_model.Weight.decimal" class="error">Weight has to be a number</span>
                <span v-if="$v.update_parcel_list_model.Weight && !$v.update_parcel_list_model.Weight.required" class="error">Weight is required</span>
                <span v-if="$v.update_parcel_list_model.Weight && !$v.update_parcel_list_model.Weight.biggerThanZero" class="error">Weight has to be bigger than zero</span>
              </div>
            </div>
            <br><br>
          </div>
        </div>
        <div class="row">
          <div class="col12">
            <!-- *********************** REFERENCES   ***********************************

                    -->

            <div class="spl-h3">
              References
            </div>
            <div class="row">
              <div v-for="(reference, index) in update_parcel_list_model.References" :key="index">
                <div
                  v-show="reference.Visible ? reference.Visible : true"
                  class="col5">
                  <form-checkbox
                    :checked="update_parcel_list_model.References[index].Update_Reference"
                    :index="index"
                    class="spl-edit-template__select-field"
                    tabindex="-1"
                    @checkboxChanged="update_Reference_Changed">
                    Update {{ reference.Reference_Type_Name }}
                  </form-checkbox>
                  <form-input
                    v-model="update_parcel_list_model.References[index].Reference_Text"
                    :index="index"
                    :enable-trim="true"
                    @input="reference_Text_Changed" />
                </div>

                <div v-if="index % 2 === 0" class="col2">
&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="spl-h3">
          Note
        </div>
        <div class="row">
          <div class="col12">
            <form-checkbox
              :checked="update_parcel_list_model.Update_Note"
              class="spl-edit-template__select-field"
              tabindex="-1"
              @checkboxChanged="update_checkbox_set($event, 'Update_Note')">
              Update Note
            </form-checkbox>
            <form-input
              v-model="update_parcel_list_model.Note"
              placeholder="Update Note"
              @input="note_Text_Changed" />
          </div>
        </div>
        <!-- *********************** Action bar for selected parcels *********************************** -->
        <div class="parcel_action_bar_spacer">
          <div class="row">
            <div class="col12">
&nbsp;
            <!-- spacer to make sure parcel-action-bar doesnt cover important info. -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- *********************** Save Cancel Reset action bar  *********************************** -->
    <div class="spl-parcel-action-bar hide-on-mobile">
      <div class="col2">
        <form-button
          wide="true"
          secondary="true"
          @onClick="reset">
          Reset
        </form-button>
      </div>
      <div class="col6">
        &nbsp;
      </div>
      <div class="col2">
        <form-button
          wide="true"
          secondary="true"
          @onClick="close">
          Cancel
        </form-button>
      </div>
      <div class="col2">
        <form-button
          :disabled="$v.$invalid || saving"
          wide="true"
          @onClick="save">
          Save
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { findIndex, debounce } from 'lodash'
import webApi from '@/webApi'
import { SearchAddressModel } from '@/webApi/DataModels'
import Helpers from '@/helpers.vue'
import constants from '@/constants'
import moment from 'moment'
import { required, minValue, integer, decimal } from 'vuelidate/lib/validators'

export default {
  name: 'ParcelUpdate',
  mixins: [Helpers],
  props: ['parcelList'],
  data () {
    return {
      is_mobile: false,
      saving: false,
      constants,
      profileData: {},
      currentSearchDebounce: null,
      update_parcel_list_model: {
        Parcel_IDs: [],
        Update_Booked_Pickup_Date: false,
        Booked_Pickup_Date: '',
        Update_Customer: false,
        Customer_ID: -1,
        Customer_Name: null,
        Update_Country: false,
        Country_ID: -1,
        Country_Name: null,
        Update_Service_Level: false,
        Service_Level_ID: -1,
        Service_Level_Name: null,
        Update_Pickup_Address: false,
        Pickup_Address_ID: -1,
        Update_Delivery_Address: false,
        Delivery_Address_ID: -1,
        Contact: {
          Active: true,
          Contact_ID: -1,
          Contact_Name: '',
          Phone_Number: ''
        },
        Contact_ID: -1,
        Update_Is_Forward: false,
        Is_Forward: null,
        References: [],

        Update_Weight: false,
        Weight: null,
        Update_Volume: false,
        Volume: null,
        Update_Dimensions: false,
        Length: null,
        Width: null,
        Height: null,
        Update_Open_Deadline: false,
        Open_Deadline: '',
        Update_Close_Deadline: false,
        Close_Deadline: '',
        Update_XRayed: false,
        Update_LMU: false,
        XRayed: null,
        Last_Mile_Upgrade: null,
        Update_Dangerous_Goods: false,
        Dangerous_Goods: null,
        Update_Note: false,
        Note: ''
      },

      common_values: {
        Parcel_IDs: [],
        Update_Booked_Pickup_Date: false,
        Booked_Pickup_Date: '',
        Update_Customer: false,
        Customer_ID: -1,
        Customer_Name: null,
        Update_Country: false,
        Country_ID: -1,
        Country_Name: null,
        Update_Service_Level: false,
        Service_Level_ID: -1,
        Service_Level_Name: null,
        Update_Pickup_Address: false,
        Pickup_Address_ID: -1,
        Update_Delivery_Address: false,
        Delivery_Address_ID: -1,
        Update_Contact: false,
        Contact_ID: 0,
        Contact_Name: null,
        Contact_Phone_Number: null,
        Update_Is_Forward: false,
        Is_Forward: null,
        References: [],

        Update_Weight: false,
        Weight: null,
        Update_Volume: false,
        Volume: null,
        Update_Dimensions: false,
        Length: null,
        Width: null,
        Height: null,
        Update_Open_Deadline: false,
        Open_Deadline: '',
        Update_Close_Deadline: false,
        Close_Deadline: '',
        Update_XRayed: false,
        Update_LMU: false,
        XRayed: null,
        Last_Mile_Upgrade: null,
        Update_Dangerous_Goods: false,
        Dangerous_Goods: null,
        Update_Note: false,
        Note: ''
        // Loading_List: null,
        // Delivery_Information: null,
      },
      found_pickup_addresses: [],
      found_delivery_addresses: [],
      pickup_address_object: {},
      edit_pickup_address_object: {},
      delivery_address_object: {},
      edit_delivery_address_object: {},
      pickup_address_formatted: '',
      delivery_address_formatted: '',
      show_create_delivery_address: false,
      show_create_pickup_address: false
    }
  },
  validations () {
    return {
      update_parcel_list_model: {
        ...this.validatedFields
      }
    }
  },
  computed: {
    ...mapGetters('country', ['countryOptions']),
    ...mapGetters('customer', ['customerOptions']),
    ...mapGetters('serviceLevel', ['serviceLevelOptions']),
    ...mapGetters('reference', ['emptyReferenceValuesWithoutCounterNumber']),

    validatedFields () {
      var fields = {}
      if (this.update_parcel_list_model.Update_Customer) {
        fields.Customer_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Country) {
        fields.Country_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Service_Level) {
        fields.Service_Level_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Service_Level) {
        fields.Service_Level_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Booked_Pickup_Date) {
        fields.Booked_Pickup_Date = { required }
      }
      if (this.update_parcel_list_model.Update_Pickup_Address) {
        fields.Pickup_Address_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Delivery_Address) {
        fields.Delivery_Address_ID = { required, minValue: minValue(0) }
      }
      if (this.update_parcel_list_model.Update_Contact) {
        fields.Contact_ID = { required, minValue: minValue(1) }
      }
      if (this.update_parcel_list_model.Update_Dangerous_Goods) {
        fields.Dangerous_Goods = { required }
      }
      if (this.update_parcel_list_model.Update_XRayed) {
        fields.XRayed = { required }
      }
      if (this.update_parcel_list_model.Update_LMU) {
        fields.Last_Mile_Upgrade = { required }
      }
      if (this.update_parcel_list_model.Update_Open_Deadline) {
        fields.Open_Deadline = { required }
      }
      if (this.update_parcel_list_model.Update_Close_Deadline) {
        fields.Close_Deadline = { required }
      }
      if (this.update_parcel_list_model.Update_Dimensions) {
        fields.Width = { integer }
        fields.Height = { integer }
        fields.Length = { integer }
      }
      if (this.update_parcel_list_model.Update_Volume) {
        fields.Volume = { decimal, required }
      }
      if (this.update_parcel_list_model.Update_Weight) {
        fields.Weight = {
          decimal,
          required,
          biggerThanZero (value) {
            if (isNaN(parseFloat(value))) {
              return true
            }
            return value > 0
          }
        }
      }
      return fields
    },
    countryOptionsWithModification () {
      return [{ value: -1, label: 'Do not update' }].concat(this.countryOptions)
    },
    customerOptionsWithModification () {
      return [{ value: -1, label: 'Do not update' }].concat(this.customerOptions)
    },
    serviceLevelOptionsWithModification () {
      return [{ value: -1, label: 'Do not update' }].concat(this.serviceLevelOptions)
    }
  },
  mounted () {
    this.get_Reference_Types()
    this.load_Common_Values()
    this.$watch(vm => [vm.update_parcel_list_model.Country_ID, vm.update_parcel_list_model.Customer_ID, vm.update_parcel_list_model.Is_Forward], val => {
      if (this.update_parcel_list_model.Country_ID !== -1 && this.update_parcel_list_model.Customer_ID !== -1) {
        this.getProfiler(this.update_parcel_list_model.Customer_ID, this.update_parcel_list_model.Country_ID, this.update_parcel_list_model.Is_Forward)
      }
    },
    {
      immediate: true,
      deep: true
    })
  },

  methods: {
    // Add Contactlist store
    ...mapActions('contact', ['getContacts']),
    ...mapActions('profiler', ['loadProfiler']),
    /// *********************** LOAD THE COMMON VALUES INTO THE SAVE OBJECT *****************************
    load_Common_Values () {
      if (this.parcelList) {
        this.common_values.Parcel_IDs = []
        for (var i = 0; i < this.parcelList.length; i++) {
          let openDeadline = this.parcelList[i].Open_Deadline
          if (this.parcelList[i].Open_Deadline === '0001-01-01T00:00:00') {
            openDeadline = ''
          }
          let closeDeadline = this.parcelList[i].Close_Deadline
          if (this.parcelList[i].Close_Deadline === '0001-01-01T00:00:00') {
            closeDeadline = ''
          }
          this.common_values.Parcel_IDs.push(this.parcelList[i].Parcel_ID)
          this.common_values.Is_Forward = this.set_JSON_Field(this.common_values.Is_Forward, this.parcelList[i].Is_Forward, i, null)
          this.common_values.Booked_Pickup_Date = this.set_JSON_Field(this.common_values.Booked_Pickup_Date, this.parcelList[i].Booked_Pickup_Date, i, '')
          this.common_values.Customer_ID = this.set_JSON_Field(this.common_values.Customer_ID, this.parcelList[i].Customer_ID, i, -1)
          this.common_values.Customer_Name = this.set_JSON_Field(this.common_values.Customer_Name, this.parcelList[i].Customer_Name, i, null)
          this.common_values.Country_ID = this.set_JSON_Field(this.common_values.Country_ID, this.parcelList[i].Country_ID, i, -1)
          this.common_values.Country_Name = this.set_JSON_Field(this.common_values.Country_Name, this.parcelList[i].Country_Name, i, null)
          this.common_values.Service_Level_ID = this.set_JSON_Field(this.common_values.Service_Level_ID, this.parcelList[i].Service_Level_ID, i, -1)
          this.common_values.Service_Level_Name = this.set_JSON_Field(this.common_values.Service_Level_Name, this.parcelList[i].Service_Level_Name, i, null)
          this.common_values.Pickup_Address_ID = this.set_JSON_Field(this.common_values.Pickup_Address_ID, this.parcelList[i].Pickup_Address_ID, i, -1)
          this.common_values.Delivery_Address_ID = this.set_JSON_Field(this.common_values.Delivery_Address_ID, this.parcelList[i].Delivery_Address_ID, i, -1)
          this.common_values.Contact_ID = this.set_JSON_Field(this.common_values.Contact_ID, this.parcelList[i].Contact_ID, i, 0)
          this.common_values.Contact_Name = this.set_JSON_Field(this.common_values.Contact_Name, this.parcelList[i].Contact_Name, i, null)
          this.common_values.Contact_Phone_Number = this.set_JSON_Field(this.common_values.Contact_Phone_Number, this.parcelList[i].Contact_Phone_Number, i, null)
          this.common_values.Is_Forward = this.set_JSON_Field(this.common_values.Is_Forward, this.parcelList[i].Is_Forward, i, null)
          this.common_values.Weight = this.set_JSON_Field(this.common_values.Weight, this.parcelList[i].Weight, i, null)
          this.common_values.Volume = this.set_JSON_Field(this.common_values.Volume, this.parcelList[i].Volume, i, null)
          this.common_values.Length = this.set_JSON_Field(this.common_values.Length, this.parcelList[i].Length, i, null)
          this.common_values.Width = this.set_JSON_Field(this.common_values.Width, this.parcelList[i].Width, i, null)
          this.common_values.Height = this.set_JSON_Field(this.common_values.Height, this.parcelList[i].Height, i, null)

          this.common_values.Open_Deadline = this.set_JSON_Field(this.common_values.Open_Deadline, openDeadline, i, '')
          this.common_values.Close_Deadline = this.set_JSON_Field(this.common_values.Close_Deadline, closeDeadline, i, '')
          this.common_values.XRayed = this.set_JSON_Field(this.common_values.XRayed, this.parcelList[i].XRayed, i, null)
          this.common_values.Last_Mile_Upgrade = this.set_JSON_Field(this.common_values.Last_Mile_Upgrade, this.parcelList[i].Last_Mile_Upgrade, i, null)
          this.common_values.Dangerous_Goods = this.set_JSON_Field(this.common_values.Dangerous_Goods, this.parcelList[i].Dangerous_Goods, i, null)
          // this.common_values.Loading_List = this.set_JSON_Field( this.common_values.Loading_List,  this.parcelList[i].Loading_List, i, "");
          // this.common_values.Delivery_Information = this.set_JSON_Field( this.common_values.Delivery_Information,  this.parcelList[i].Delivery_Information, i, null);

          this.pickup_address_formatted = this.set_JSON_Field(this.pickup_address_formatted
            , this.format_Address_Fields(this.parcelList[i].Pickup_Name_1
              , this.parcelList[i].Pickup_Street_1
              , this.parcelList[i].Pickup_Postal_Code
              , this.parcelList[i].Pickup_City
              , this.parcelList[i].Pickup_Country_Name)
            , i, '\n\n\n\n\n')

          // populate the addresses array with the already selected addresses
          var pickupAddress = {}
          pickupAddress.Address_ID = this.parcelList[i].Pickup_Address_ID
          pickupAddress.Name_1 = this.parcelList[i].Pickup_Name_1
          pickupAddress.Street_1 = this.parcelList[i].Pickup_Street_1
          pickupAddress.Postal_Code = this.parcelList[i].Pickup_Postal_Code
          pickupAddress.City = this.parcelList[i].Pickup_City
          pickupAddress.Country_Name = this.parcelList[i].Pickup_Country_Name
          var searchObject = {}
          searchObject.value = pickupAddress.Address_ID
          if (findIndex(this.found_pickup_addresses, searchObject) === -1) {
            this.addFoundAddress(pickupAddress, 'pickup')
          }

          this.delivery_address_formatted = this.set_JSON_Field(this.delivery_address_formatted
            , this.format_Address_Fields(this.parcelList[i].Delivery_Name_1
              , this.parcelList[i].Delivery_Street_1
              , this.parcelList[i].Delivery_Postal_Code
              , this.parcelList[i].Delivery_City
              , this.parcelList[i].Delivery_Country_Name)
            , i, '\n\n\n\n\n')

          var deliveryAddress = {}
          deliveryAddress.Address_ID = this.parcelList[i].Delivery_Address_ID
          deliveryAddress.Name_1 = this.parcelList[i].Delivery_Name_1
          deliveryAddress.Street_1 = this.parcelList[i].Delivery_Street_1
          deliveryAddress.Postal_Code = this.parcelList[i].Delivery_Postal_Code
          deliveryAddress.City = this.parcelList[i].Delivery_City
          deliveryAddress.Country_Name = this.parcelList[i].Delivery_Country_Name
          var deliveryAddressSearchObject = {}
          deliveryAddressSearchObject.value = deliveryAddress.Address_ID
          if (findIndex(this.found_delivery_addresses, deliveryAddressSearchObject) === -1) {
            this.addFoundAddress(deliveryAddress, 'delivery')
          }

          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.SHIPMENT_REFERENCE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.FORWARDER_REFERENCE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.DELIVERY_NOTE_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.ORDER_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.SERVICE_ORDER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.BARCODE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.CMR_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.PICKUP_REFERENCE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.STORAGE_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.AWB, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.HAWB, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.CUSTOMS_DECLARATION_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.CUSTOMER_RETURN_REFERENCE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.RETURN_BARCODE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.FORWARDER_RETURN_REFERENCE, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.RETURN_COUNTER_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.CUSTOMER_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.FORWARD_COUNTER_NUMBER, i)
          this.set_Common_Reference(constants.REFERENCE_TYPE_NAME.MATERIAL_NUMBER, i)
        }
      }

      // Copy the common_values object to the update_parcel_list_model object
      this.update_parcel_list_model = JSON.parse(JSON.stringify(this.common_values))

      if (this.update_parcel_list_model.Country_ID !== -1 && this.update_parcel_list_model.Customer_ID !== -1) {
        this.getProfiler(this.update_parcel_list_model.Customer_ID, this.update_parcel_list_model.Country_ID, this.update_parcel_list_model.Is_Forward)
      }
      // Reset the update flag / checkbox
      this.update_parcel_list_model.Update_Booked_Pickup_Date = false
      this.update_parcel_list_model.Update_Customer = false
      this.update_parcel_list_model.Update_Country = false
      this.update_parcel_list_model.Update_Service_Level = false
      this.update_parcel_list_model.Update_Pickup_Address = false
      this.update_parcel_list_model.Update_Delivery_Address = false
      this.update_parcel_list_model.Update_Contact = false
      this.update_parcel_list_model.Update_Is_Forward = false
      this.update_parcel_list_model.Update_Weight = false
      this.update_parcel_list_model.Update_Volume = false
      this.update_parcel_list_model.Update_Dimensions = false
      this.update_parcel_list_model.Update_Open_Deadline = false
      this.update_parcel_list_model.Update_Close_Deadline = false
      this.update_parcel_list_model.Update_XRayed = false
      this.update_parcel_list_model.Update_LMU = false
      this.update_parcel_list_model.Update_Dangerous_Goods = false
      this.getContacts({
        customerID: this.update_parcel_list_model.Customer_ID,
        countryID: this.update_parcel_list_model.Country_ID
      })
    },

    /// Help function for loading the parcel_list values into the common_values object.
    /// The idea is to load the value if all parcels have the same value
    /// If the parcels have different values we add the empty value
    /// We loop through all parcels in load_Common_Values, and the first parcel (index === 0) fills all values,
    /// then we switch to empty value if the next parcels does not match.
    set_JSON_Field (commonValuesValue, parcelListValue, index, emptyValue) {
      if (index === 0) {
        return parcelListValue
      } else if (commonValuesValue === parcelListValue) {
        return parcelListValue
      } else {
        return emptyValue
      }
    },
    /// Formats the address field to a nice string.
    format_Address_Fields (name, street, postalCode, city, countryName) {
      var address = ''

      address = '\n' + name +
                '\n' + street +
                '\n' + postalCode + ' ' + city + '  —  ' + countryName + '\n'

      return address
    },
    getProfiler (customer_id, country_id, is_forward) {
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        this.profileData = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
        this.update_parcel_list_model.References.forEach(reference => {
          if (this.profileData !== null && this.profileData.Fields.length > 0) {
            const found = this.profileData.Fields.find(el => el.Name.toLowerCase() === reference.Reference_Type_Name.toLowerCase())
            if (found) {
              reference.Visible = found.Visible
            } else {
              reference.Visible = true
            }
          } else {
            reference.Visible = true
          }
        })
        this.$forceUpdate()
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    /// This will update the common_values reference if the index === 0 or the list parcel reference !== the common_values
    set_Common_Reference (referenceTypeName, index) {
      var listReferenceText
      if (index === 0) {
        // First parcel in list => set reference
        // Get the parcel_list reference value
        listReferenceText = this.get_Reference_Text(this.parcelList[index].References, referenceTypeName)
        this.set_Reference_Text(referenceTypeName, listReferenceText)
      } else {
        /// The first parcel has been checked. If hte parcel_son reference is set to null now, dont change
        // Get the json reference value
        var jsonReferenceText = this.get_Reference_Text(this.common_values.References, referenceTypeName)

        if (jsonReferenceText) {
          // We have a value, check if the new parcel has the same value as the old ones.
          listReferenceText = this.get_Reference_Text(this.parcelList[index].References, referenceTypeName)

          if (listReferenceText !== jsonReferenceText) {
            // The old values are not the same as the new parcel. Set common_values reference to null
            this.set_Reference_Text(referenceTypeName, null)
          }
        }
      }
    },
    /// Get the reference text from a list of references based on the referenceName
    get_Reference_Text (references, referenceTypeName) {
      for (var i in references) {
        if (references[i].Reference_Type === referenceTypeName) {
          return references[i].Reference_Text
        }
      }
      return ''
    },

    /// Set the common_values reference to the new value
    set_Reference_Text (referenceName, value) {
      for (var i in this.common_values.References) {
        if (this.common_values.References[i].Reference_Type_Name === referenceName) {
          this.common_values.References[i].Reference_Text = value
          this.common_values.References[i].Update_Reference = false
        }
      }
    },

    /// ************************************* LOAD UPDATE INFO ******************************************

    // Generic function to get the Update state from the Checkbox
    update_checkbox_set (value, key) {
      this.update_parcel_list_model[key] = value
    },

    // ************************ Set functions for dropdowns ************************

    // Set the customer ID from the dropdown choice
    customer_set (item) {
      if (!item || this.update_parcel_list_model.Customer_ID === item.value) return // Leave, the customer is already correct.

      this.update_parcel_list_model.Customer_ID = item.value
      this.update_parcel_list_model.Customer_Name = item.label

      // Clear related related fields
      this.update_parcel_list_model.Pickup_Address_ID = -1
      this.update_parcel_list_model.Delivery_Address_ID = -1
      this.pickup_address_object = {}
      this.pickup_address_formatted = ''
      this.delivery_address_object = {}
      this.delivery_address_formatted = ''

      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_Customer = this.update_parcel_list_model.Customer_ID !== this.common_values.Customer_ID && this.update_parcel_list_model.Customer_ID >= 0
    },
    // Set the country ID from the dropdown choice
    country_set (item) {
      this.update_parcel_list_model.Country_ID = item.value
      this.update_parcel_list_model.Country_Name = item.label

      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_Country = this.update_parcel_list_model.Country_ID !== this.common_values.Country_ID && this.update_parcel_list_model.Country_ID >= 0
    },
    // If the contact component changes we update the update model
    update_Contact (contact) {
      if (contact === null) {
        this.update_parcel_list_model.Update_Contact = false
        this.update_parcel_list_model.Contact_ID = 0
      } else {
        this.update_parcel_list_model.Update_Contact = true
        this.update_parcel_list_model.Contact_ID = contact.value
        this.callTouch(this.$v.update_parcel_list_model.Contact_ID)
      }
    },

    // Set the service level ID from the dropdown choice
    service_level_set (item) {
      this.update_parcel_list_model.Service_Level_ID = item.value
      this.update_parcel_list_model.Service_Level_Name = item.label

      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_Service_Level = this.update_parcel_list_model.Service_Level_ID !== this.common_values.Service_Level_ID && this.update_parcel_list_model.Service_Level_ID >= 0
    },

    // Set changed flag & checkbox to true
    booked_Pickup_Date_Changed () {
      this.update_parcel_list_model.Booked_Pickup_Date = moment(this.update_parcel_list_model.Booked_Pickup_Date).format('YYYY-MM-DDTHH:mm:ss')
      this.update_parcel_list_model.Update_Booked_Pickup_Date = this.update_parcel_list_model.Booked_Pickup_Date !== this.common_values.Booked_Pickup_Date
    },

    direction_set (value) {
      this.update_parcel_list_model.Is_Forward = value.value
      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_Is_Forward = this.update_parcel_list_model.Is_Forward !== this.common_values.Is_Forward && this.update_parcel_list_model.Is_Forward != null
    },

    // Set the dangerous goods
    dangerous_goods_set (item) {
      this.update_parcel_list_model.Dangerous_Goods = item.value

      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_Dangerous_Goods = this.update_parcel_list_model.Dangerous_Goods !== this.common_values.Dangerous_Goods && this.update_parcel_list_model.Dangerous_Goods != null
    },

    // Set the xray
    xrayed_set (item) {
      this.update_parcel_list_model.XRayed = item.value
      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_XRayed = this.update_parcel_list_model.XRayed !== this.common_values.XRayed && this.update_parcel_list_model.XRayed != null
    },

    // Set the last mile upgrade
    lmu_set (item) {
      this.update_parcel_list_model.Last_Mile_Upgrade = item.value
      // Update the checkbox / update flag
      this.update_parcel_list_model.Update_LMU = this.update_parcel_list_model.Last_Mile_Upgrade !== this.common_values.Last_Mile_Upgrade && this.update_parcel_list_model.Last_Mile_Upgrade != null
    },

    // Set changed flag & checkbox to true
    open_Deadline_Changed () {
      if (this.update_parcel_list_model.Open_Deadline === null) {
        this.update_parcel_list_model.Update_Close_Deadline = false
        return
      }
      this.update_parcel_list_model.Open_Deadline = moment(this.update_parcel_list_model.Open_Deadline).format('YYYY-MM-DDTHH:mm:ss')
      this.update_parcel_list_model.Update_Open_Deadline = this.update_parcel_list_model.Open_Deadline !== this.common_values.Open_Deadline
    },

    // Set changed flag & checkbox to true
    close_Deadline_Changed () {
      if (this.update_parcel_list_model.Close_Deadline === null) {
        this.update_parcel_list_model.Update_Close_Deadline = false
        return
      }
      this.update_parcel_list_model.Close_Deadline = moment(this.update_parcel_list_model.Close_Deadline).format('YYYY-MM-DDTHH:mm:ss')
      this.update_parcel_list_model.Update_Close_Deadline = this.update_parcel_list_model.Close_Deadline !== this.common_values.Close_Deadline
    },

    // Set changed flag & checkbox to true
    dimensions_Changed () {
      this.update_parcel_list_model.Update_Dimensions = this.update_parcel_list_model.Length !== this.common_values.Length ||
                                                this.update_parcel_list_model.Width !== this.common_values.Width ||
                                                this.update_parcel_list_model.Height !== this.common_values.Height
    },

    // Set changed flag & checkbox to true
    volume_Changed () {
      this.update_parcel_list_model.Update_Volume = this.update_parcel_list_model.Volume !== this.common_values.Volume
    },
    // Set changed flag & checkbox to true
    weight_Changed () {
      this.update_parcel_list_model.Update_Weight = this.update_parcel_list_model.Weight !== this.common_values.Weight
    },

    getAddresses (search, type) {
      if (this.currentSearchDebounce) {
        this.currentSearchDebounce.cancel()
      }
      this.currentSearchDebounce = debounce(this.startAddressSearch, 300)
      this.currentSearchDebounce(search, type)
    },

    //* ********************************* ADDRESSES *******************************************/
    startAddressSearch (search, type) {
      if (search === '') {
        return
      }
      if (this.update_parcel_list_model.Customer_ID <= 0) {
        // We need to have the same customer id (!= unknown) set for all parcels to be able
        // to work with addresses
        window.bus.$emit('openErrorModal', 'You cannot update parcel address since not all parcels are from the same customer.')
      }
      // Addressmodel for the search
      var addressSearchModel = {
        Customer_ID: this.update_parcel_list_model.Customer_ID,
        Search_Text: search,
        Maximum_Number_Of_Rows: 10
      }

      webApi.address.get_Address_List(addressSearchModel)
        .then((response) => {
          if (type === 'delivery') {
            this.found_delivery_addresses = []
          } else {
            this.found_pickup_addresses = []
          }
          var responseAddress = response.data
          responseAddress.forEach(address => {
            // Build the  string shown in the dropdown
            this.addFoundAddress(address, type)
          })
        }).catch((response) => {
          window.bus.$emit('openErrorModal', 'error loading event info: ' + response.data.ExceptionMessage)
        })
    },

    /**
     * Adds an adress to the addresses array
     */
    addFoundAddress (address, type) {
      var addressLabel =
              this.truncate(address.Name_1, 40) + ', ' +
              this.truncate(address.Street_1, 40) + ', ' +
              this.truncate(address.Postal_Code, 20) + ', ' +
              this.truncate(address.City, 20) + ', ' +
              this.truncate(address.Country_Name, 20)

      var addressObject = {
        label: addressLabel,
        value: address.Address_ID,
        address_object: address
      }
      if (type === 'delivery') {
        this.found_delivery_addresses.push(addressObject)
      } else {
        this.found_pickup_addresses.push(addressObject)
      }
    },
    // ************************ New Pickup address was chosen from dopdown ************************
    update_Pickup_Address (addressItem) {
      if (addressItem === null) {
        this.update_parcel_list_model.Pickup_Address_ID = -1
        this.pickup_address_object = {}
        this.pickup_address_formatted = ''
        this.update_parcel_list_model.Update_Pickup_Address = false
        return
      }
      this.update_parcel_list_model.Pickup_Address_ID = addressItem.value
      this.pickup_address_object = {
        Pickup_Address_ID: addressItem.value,
        Name_1: this.truncate(addressItem.address_object.Name_1, 75),
        Street_1: addressItem.address_object.Street_1,
        Postal_Code: addressItem.address_object.Postal_Code,
        City: addressItem.address_object.City,
        Country_Name: addressItem.address_object.Country_Name
      }

      this.pickup_address_formatted = ''
      this.pickup_address_formatted += '\n' + this.pickup_address_object.Name_1
      this.pickup_address_formatted += '\n' + this.pickup_address_object.Street_1
      this.pickup_address_formatted += '\n' + this.pickup_address_object.Postal_Code + ' ' + this.pickup_address_object.City
      this.pickup_address_formatted += '\n' + this.pickup_address_object.Country_Name

      // Update the checkbox / update flag
      if (this.common_values.Pickup_Address_ID !== addressItem.value) {
        this.update_parcel_list_model.Update_Pickup_Address = true
      }
    },
    // ************************ New delivey address was chosen from dopdown ************************
    update_Delivery_Address (addressItem) {
      if (addressItem === null) {
        this.update_parcel_list_model.Delivery_Address_ID = -1
        this.delivery_address_object = {}
        this.delivery_address_formatted = ''
        this.update_parcel_list_model.Update_Delivery_Address = false
        return
      }
      this.update_parcel_list_model.Delivery_Address_ID = addressItem.value
      this.delivery_address_object = {
        Delivery_Address_ID: addressItem.value,
        Name_1: this.truncate(addressItem.address_object.Name_1, 75),
        Street_1: addressItem.address_object.Street_1,
        Postal_Code: addressItem.address_object.Postal_Code,
        City: addressItem.address_object.City,
        Country_Name: addressItem.address_object.Country_Name
      }

      this.delivery_address_formatted = ''
      this.delivery_address_formatted += '\n' + this.delivery_address_object.Name_1
      this.delivery_address_formatted += '\n' + this.delivery_address_object.Street_1
      this.delivery_address_formatted += '\n' + this.delivery_address_object.Postal_Code + ' ' + this.delivery_address_object.City
      this.delivery_address_formatted += '\n' + this.delivery_address_object.Country_Name

      // Update the checkbox / update flag
      if (this.common_values.Delivery_Address_ID !== addressItem.value) {
        this.update_parcel_list_model.Update_Delivery_Address = true
      }
    },

    //* ****************************************** Create Address Functions *************************************

    // Show the Create Address modal
    show_Edit_Delivery_Address () {
      this.edit_delivery_address_object = this.delivery_address_object
      this.show_create_delivery_address = true
    },

    show_Create_Delivery_Address () {
      this.edit_delivery_address_object = {}
      this.show_create_delivery_address = true
    },
    show_Edit_Pickup_Address () {
      this.edit_pickup_address_object = this.pickup_address_object
      this.show_create_pickup_address = true
    },
    // Show the Create Address modal
    show_Create_Pickup_Address () {
      this.edit_pickup_address_object = {}
      this.show_create_pickup_address = true
    },
    close_Address () {
      this.show_create_delivery_address = false
      this.show_create_pickup_address = false
    },
    pickup_Address_Created (addressModel) {
      var addressItem = {
        value: addressModel.Address_ID,
        address_object: {
          Name_1: this.truncate(addressModel.Name_1, 75),
          Street_1: addressModel.Street_1,
          Postal_Code: addressModel.Postal_Code,
          City: addressModel.City,
          Country_Name: addressModel.Country_Name
        }
      }
      this.addFoundAddress(addressModel, 'pickup')
      this.update_Pickup_Address(addressItem)
      this.show_create_pickup_address = false
    },
    delivery_Address_Created (addressModel) {
      var addressItem = {
        value: addressModel.Address_ID,
        address_object: {
          Name_1: this.truncate(addressModel.Name_1, 75),
          Street_1: addressModel.Street_1,
          Postal_Code: addressModel.Postal_Code,
          City: addressModel.City,
          Country_Name: addressModel.Country_Name
        }
      }

      this.addFoundAddress(addressModel, 'delivery')
      this.update_Delivery_Address(addressItem)
      this.show_create_delivery_address = false
    },

    // ************************ Get the reference types ************************
    // Gets all the reference types and adds them to the book model, except the counter number

    get_Reference_Types () {
      this.common_values.References = this.emptyReferenceValuesWithoutCounterNumber
    },

    reference_Text_Changed (value, index) {
      this.update_parcel_list_model.References[index].Update_Reference = true
    },
    update_Reference_Changed (value, index) {
      this.update_parcel_list_model.References[index].Update_Reference = value
    },
    // Changes the flag if the Note Field was updated
    note_Text_Changed (value) {
      if (value !== undefined) {
        this.update_parcel_list_model.Update_Note = true
      }
    },

    /// Close without saving
    close () {
      this.$emit('parcel_Update_Cancelled', 'Could not load the customers')
    },

    /// Save the updated parcels
    save () {
      // Disable the button while saving
      this.saving = true

      // call update parcel web API
      // Call the api and pass the filtered columns and values
      webApi.parcel.update_Parcel_List(this.update_parcel_list_model).then((response) => {
        // Parcel was succesfully updated so we update the blockContent
        this.saving = false
        this.$emit('parcel_Update_Saved')
        this.$toast('The parcels was updated with your changes.', constants.defaultToastOptions())
      }).catch((response) => {
        window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        this.saving = false
      })
    },

    reset () {
      this.load_Common_Values()
    },
    callTouch (valueToTouch) {
      if (valueToTouch && valueToTouch.$touch) {
        valueToTouch.$touch()
      }
    }
  }
}
</script>

<style lang="scss">
  .spl-edit-template {
    & .spl-row-space {
      margin-bottom: 30px
    }
    padding-top: 30px;
    & .spl-h3 {
      margin-top: 30px;
      margin-bottom: 40px;
      position: relative;

      &::before {
        content: "";
        border-bottom: 3px solid black;
        opacity: 0.3;
        width: 30px;
        position: absolute;
        bottom: -13px;
      }
    }
    & .spl-h3--first {
      margin-top: 0px !important;
    }
    &__select-field {
      .spl-checkbox {
        height: 14px;
        width: 14px;
        margin: 0 4px 0 0;
      }
      span {
        color: #e79a02;
        font-family: "PT Mono", monospace;
        font-size: 9px;
        font-weight: 700;
        line-height: 12px;
        margin-top: 2px;
        letter-spacing: 1px;
      }
    }
  }
</style>
